<!--
 * @Author: hongye
 * @Date: 2020-10-28 16:54:24
 * @LastEditTime: 2023-12-26 16:46:23
 * @Description:
-->
<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav active"
      >{{ $lang('在线文档') }}</span
      >
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom">
      <online-doc :onlineData="onlineData">
        <template #api_addr_info>
          <p class="api_addr_info">{{ $lang('地址：使用接入方提供的URL') }}</p>
          <p class="api_addr_info">{{ $lang('请求方法') }}：<span>POST</span></p>
          <p class="api_addr_info">{{ $lang('数据类型') }}：<span>X-WWW-FORM-URLENCODED </span></p>
          <p class="api_addr_info">{{ $lang('响应类型') }}：<span>JSON</span></p>
        </template>
      </online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

export default {
  name: "statusFeedback",

  components: {onlineDoc},
  data() {
    const that = this
    return {
      onlineData: {
        //接口描述
        apiDesc: that.$lang("接入方在提供了快递轨迹推送相关信息并完成了下订单操作后，当订单相关的运单轨迹变化时，系统会根据接入方配置的推送账户主动推送物流信息。"),

        //参数描述  START
        postDataList: [
          //   请求头参数
          {
            title: 'Headers',
            value: [
              {
                name: "apiAccount",
                type: "Number",
                require: "Y",
                normal: "",
                describe: that.$lang("接入方在平台的api账户标识")
              },
              {name: "digest", type: "String", require: "Y", normal: "", describe: that.$lang("签名字符串,请在签名工具内获取")},
              {
                name: "timestamp",
                type: "Number",
                require: "Y",
                normal: "",
                describe: that.$lang('时间戳，毫秒') + '<br/>' + that.$lang('时区：UTC+7'),
                isHtml: true
              },
              {
                name: "bizContent",
                type: "String",
                require: "Y",
                normal: "",
                describe: that.$lang('业务参数模块内json格式的string类型'),
              }
            ]
          },
          {
            title: '请求参数',
            value: [
              {name: "billCode", type: "String(30)", require: "Y", normal: "", describe: that.$lang('运单号')},
              {name: "txlogisticId", type: "String", require: "Y", normal: "", describe: that.$lang('客户订单号')},
              {
                name: "details",
                type: "Object | Array",
                require: "Y",
                normal: "",
                describe: that.$lang('轨迹详情'),
                children: [
                  {name: "scanTime", type: "String", require: "Y", normal: "", describe: that.$lang('扫描时间')},
                  {name: "desc", type: "String", require: "Y", normal: "", describe: that.$lang('轨迹描述')},
                  {name: "scanTypeCode", type: "int", require: "Y", normal: "106：" +  that.$lang('已取件'), describe: that.$lang('扫描类型编码，扫描类型') + '<br/>' + 'COLLECTION(10,"' + that.$lang('快件揽收') + '"),' + '<br/>' + 'SEND(50, "' + that.$lang('发件扫描') + '"),' + '<br/>' + 'ARRIVAL(92, "' + that.$lang('到件扫描') + '"),' + '<br/>' + 'DELIVERY(94, "' + that.$lang('出仓扫描') + '"),' + '<br/>' + 'SIGN(100, "' + that.$lang('快件签收') + '"),' + '<br/>' + 'RETURN_PARCEL(176, "' + that.$lang('退件扫描') + '"),' + '<br/>' + 'RETURN_SIGN(173, "' + that.$lang('退件签收') + '"),' + '<br/>' + 'ISSUE(110, "' + that.$lang('问题件扫描') + '")', isHtml: true },
                  {
                    name: "scanTypeName",
                    type: "String",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('扫描类型'),
                    isHtml: true
                  },
                  {
                    name: "reason",
                    type: "String",
                    require: "N",
                    normal: "",
                    describe: that.$lang('取件失败、派件失败原因')
                  },
                  {
                    name: "scanNetworkName",
                    type: "String",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('扫描网点名称')
                  },
                  {name: "scanNetworkId", type: "String", require: "Y", normal: "", describe: that.$lang('扫描网点ID')},
                  {name: "staffName", type: "String", require: "Y", normal: "", describe: that.$lang('业务员姓名')},
                  {
                    name: "staffContact",
                    type: "String",
                    require: "N",
                    normal: "",
                    describe: that.$lang('业务员联系方式')
                  },
                  {
                    name: "scanNetworkContact",
                    type: "String",
                    require: "N",
                    normal: "",
                    describe: that.$lang('扫描网点联系方式')
                  },
                  {
                    name: "scanNetworkProvince",
                    type: "String",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('扫描网点省份')
                  },
                  {
                    name: "scanNetworkCity",
                    type: "String",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('扫描网点城市')
                  },
                  {
                    name: "scanNetworkArea",
                    type: "String",
                    require: "Y",
                    normal: "",
                    describe: that.$lang('扫描网点区/县')
                  },
                  {
                    name: "sigPicUrl",
                    type: "",
                    require: "",
                    normal: "",
                    describe: ''
                  }
                ]
              }
            ]
          }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList: [
          //   响应参数
          {
            title: '响应参数',
            value: [
              {
                name: "code",
                type: "String(10)",
                require: "Y",
                normal: "1",
                describe: that.$lang('是否成功') + '<br/>' + that.$lang('1为成功，其他为失败，此时关注msg中返回的失败原因'),
                isHtml: true,
              },
              {name: "msg", type: "String(100)", require: "Y", normal: "success", describe: that.$lang('返回信息')},
              {name: "data", type: "String", require: "Y", normal: "", describe: ''},
            ]
          }
        ],
        //请求示例
        requestCode: JSON.parse(`{"billCode":"801100195141","details":[{"scanByCode":"0848881999","scanByContact":"15225714573","scanByName":"小钱","scanNetworkArea":"Phường Nguyễn Thái Bình-028QQ107","scanNetworkCity":"Quận 1","scanNetworkCode":"084888","scanNetworkContact":"000101010","scanNetworkName":"TEST-888","scanNetworkProvince":"Hồ Chí Minh","scanNetworkTypeName":"一级网点","scanTime":"2024-06-21T13:23:56","scanTypeCode":10,"scanTypeName":"快件揽收","waybillId":"801100195141","weight":666.66}]}`),
        //返回示例
        //返回示例
        responseCode: JSON.parse(`{"code":"1","msg":"success","data":null}`),
      }
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>
